import PropTypes from "prop-types";
import { Tooltip } from "primereact/tooltip";
import { useIntl } from "react-intl";

const Label = ({
  label,
  disabled,
  required,
  htmlFor,
  infoMessage,
  infoPosition = "top",
}) => {
  const intl = useIntl();
  const infoIconId = `info-icon-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div
      htmlFor={htmlFor}
      className={`edexlms-field-label ${(required && "required") || ""} ${
        disabled ? "disabled" : ""
      }`}
    >
      <span className="label-text">{label}</span>
      {infoMessage && !disabled && (
        <>
          <i
            id={infoIconId}
            className="pi pi-info-circle info-icon ml-2"
            style={{
              fontSize: "0.875rem",
              color: "#6b7280",
              cursor: "pointer",
            }}
          />
          <Tooltip
            target={`#${infoIconId}`}
            content={infoMessage ? intl.formatMessage({ id: infoMessage }) : ""}
            position={infoPosition}
          />
        </>
      )}
    </div>
  );
};

Label.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  htmlFor: PropTypes.string,
  infoMessage: PropTypes.string,
  infoPosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
};

export default Label;
